import React, { useEffect } from "react";
import useLayoutStore from "stores/useLayoutStore";
import { Error403 } from "containers/Error/Error403";
const Error403Page = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <Error403 />
    </>
  );
};

export default Error403Page;
